import { render } from "./AssignManyAccount.vue?vue&type=template&id=79cadc3b"
import script from "./AssignManyAccount.vue?vue&type=script&lang=js"
export * from "./AssignManyAccount.vue?vue&type=script&lang=js"

import "./AssignManyAccount.vue?vue&type=style&index=0&id=79cadc3b&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__